<footer>
  <div class="footer-container container">
    <div class="logo">
      <cx-abstract [component]="components | cmsComponent: CX_COMPONENT.LOGO" />
    </div>

    <div class="footer-container-links">
      <cx-abstract [component]="components | cmsComponent: CX_COMPONENT.FOOTER_NAVIGATION_BAR" />
      <cx-abstract [component]="components | cmsComponent: CX_COMPONENT.TERM_LINK" />
    </div>
  </div>

  <copy-right></copy-right>
</footer>
